import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import './BillingForNoDriver.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate, faMoneyBill, faBuildingColumns, faBackward } from '@fortawesome/free-solid-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Alert from 'react-bootstrap/Alert';
import fetchData from '../../../function/fetchData';
import Items from '../invoiceComponents/Items';
import 'moment/locale/cs';
import { addDays, format } from 'date-fns';
import { Container } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';

// Aktuální den
const getActualDate = () => {
    // Získání aktuálního data
    const currentDate = new Date();
    

    // Formátování data do DD.MM.YYYY
    return format(currentDate, 'yyyy-MM-dd');
}


// Posune datum o 14 dní
const getDateTwoWeeksFromNow = () => {
    // Získání aktuálního data
    const currentDate = new Date();
    
    // Posunutí aktuálního data o 14 dní
    const futureDate = addDays(currentDate, 14);

    // Formátování data do DD.MM.YYYY
    return format(futureDate, 'yyyy-MM-dd');
}



const BillingForNoDriver = ({  server, token  , onShow, onHide,  rows, setRows , fetchDataFromServer}) => {
    let invoicePrice = 0;
    const [name, setName] = useState('')
    const [address, setAddress] = useState('')
    const [ic, setIc] = useState('')

    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState("")
    const [date, setDate] = useState( getActualDate() )
    const [dateTillPay, setDateTillPay] = useState(getDateTwoWeeksFromNow())
    const [payedBy, setPayedBy] = useState(null)

    // Spočítá totální cenu
    if (rows.length > 0) {
        rows.forEach(one => {
            invoicePrice += parseInt(one.price);
            
        });
    }



    const handleRadioChange = (event) => {
        setPayedBy(event.target.value);
      };

    // Odešle data k uložení
    const handleSendData = () => {
       
        const itemsToSend = rows.map(({ id, ...rest }) => rest);
        if(itemsToSend.length > 0 && name.length > 5 && address.length > 5){
            setLoading(true)
            fetchData(server + "api2/adminScheduleController.php", {
                token: token, 
                action: "SAVE_INVOICE",
                items: itemsToSend,
                email: email,
                invoiceTo: {name, address, ic},
                dateTillPay: dateTillPay,
                payedBy: payedBy,
                date:date,
    
            }).then((res)=> {
                console.log(res)
                if(res.status !== "OK"){
                    alert('Chyba spojení, zkuste to prosím později.')
                } 
                onHide()
            })
        } else {
            alert('Přidejte alespoň jednu položku k fakturaci a také musí být vyplněno, komu budeme fakturovat.')
        } 

    }
    


    const handleAddRow = (id = null, item = '' , price = 0, schedule = false) => {
        setRows([...rows, {id,  quantity: 1, item: item, price: price , schedule}]);
    };
    // Odebírač klasického itemu
    const handleRemoveRow = (index) => {
        setRows(rows.filter((_, i) => i !== index));
    };


    return (
        <Modal
            show={onShow}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton style={{ backgroundColor: '#eee' }}>
                <Modal.Title id="contained-modal-title-vcenter" >
                    Fakturace
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
  
            {/* Komu se bude fakturovat */}
            <h3 style={{color: 'rgb(5, 44, 101)'}}>Fakturace pro </h3>
            <Alert  variant={'primary'} style={{flexDirection: 'column', display: 'flex', gap: 5}}>
                <input placeholder='Celé jméno' className='prettyForm' value={name} onChange={(e)=> setName(e.target.value)}/>
                <input placeholder='Adresa + město' className='prettyForm' value={address} onChange={(e)=> setAddress(e.target.value)}/>
                <input placeholder='Ičo' className='prettyForm' value={ic} onChange={(e)=> setIc(e.target.value)}/>
                <br></br>
                Datum vystavení: <input type='date' className='prettyForm' value={date} onChange={(e)=>setDate(e.target.value)}/>
                Splatnost: <input type='date' className='prettyForm' value={dateTillPay} onChange={(e)=>setDateTillPay(e.target.value)}/>
            </Alert>
       
            
            {/* Položky faktury */}
            <br></br>
            <Items rows={rows} setRows={setRows} handleAddRow={handleAddRow} handleRemoveRow={handleRemoveRow}/>
            <br></br>
            <h3 style={{color: 'rgb(5, 44, 101)'}}>Celkem na faktuře: {invoicePrice} Kč</h3>
            <div>
            <Container style={{ gap: 10 }}>
                <Form.Check
                type={'radio'}
                name="payment"
                value="cache"
                checked={payedBy === 'cache'}
                onChange={handleRadioChange}
                />
                <label>Faktura hotově(zaplaceno)</label>
            </Container>
            <Container style={{ gap: 10 }}>
                <Form.Check
                type={'radio'}
                name="payment"
                value="card"
                checked={payedBy === 'card'}
                onChange={handleRadioChange}
                />
                <label>Převodem</label>
            </Container>
            
            </div>
               
        
            </Modal.Body>
            <Modal.Footer>
                <div>
                    Na email:
                    <input value={email} onChange={(e)=> setEmail(e.target.value)} style={{border: 'none', width: 200, marginLeft: 10,borderBottom: '1px solid grey' }}/>
                   
                </div>
                <div style={{flex: 1}}></div>
                {!loading &&
                    <Button variant="success" onClick={handleSendData}>  
                        Odeslat fakturu
                    </Button>
                }
                {loading &&
                <Button variant="success" disabled>  
                    <Spinner animation="border" role="status" size="sm">
                    </Spinner>
                    Ukládám
                </Button>
                }
                <Button onClick={onHide}>Zavřít</Button>
        
            </Modal.Footer>
        </Modal>
    )
}

export default BillingForNoDriver
